/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { Fragment, useState, useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { arrayToFlat } from 'app/utils';
import { useUtils, useConfig } from 'app/hooks';
import { Svg, Button, ModalCarousel, Player, TitleWithPoster, Loader } from 'app/components';
import { EntityGallery, EntityInfo, isClassBlock, printInfo } from 'app/components/Entity';
import TitleWithPosterComponent, { toMinutes } from 'app/components/TitleWithPoster';
import { AsideMovieDetails, MovieDescription } from '../styles';
import parse from 'html-react-parser';
import { useRef } from 'react';

const propTypes = {
  movieDetails: PropTypes.oneOfType([PropTypes.array, PropTypes.any]).isRequired,
  isVisible: PropTypes.bool.isRequired
};

const Aside = ({ movieDetails, isVisible, isEntityGalleryShown }) => {
  const [t, i18n] = useTranslation();
  const [isFullDescription, showMore] = useState(false);
  const { getDateWithOffset } = useUtils();
  const { country,
    showingOptions, } = useConfig();
  const technologiesContent = useRef(null);

  const {
    titleOriginalCalculated,
    descriptionCalculated,
    descriptionShortCalculated,
    trailers,
    rating,
    ratingGetmesh,
    ratingGetmeshEn,
    runTime,
    distributorName,
  } = movieDetails;

  const startDate =
    movieDetails.startDate && format(getDateWithOffset(movieDetails.startDate), 'dd.MM.yyy');
  const startCMSYear = movieDetails.movieStartCMS ? format(getDateWithOffset(movieDetails.movieStartCMS), 'yyy') : null;
  const actors = movieDetails.actors ? movieDetails.actors.join(', ') : null;
  const directors = movieDetails.directors ? movieDetails.directors.join(', ') : null;
  const [trailerToShow, selectTrailer] = useState(trailers && trailers.length ? 0 : null);

  const [ratingList, setRatingList] = useState([]);
  const [technologiesCMSList, setTechnologiesCMSList] = useState('');
  const [versionCMSList, setVersionCMSList] = useState('');
  const [isModal, setModal] = useState(false);
  const [technologiesContentList, setTechnologiesContentList] = useState([]);
  const [technologiesContentValue, setTechnologiesContentValue] = useState(false);
  const [gallery, setGallery] = useState([]);
  const [isGallery, setIsGallery] = useState(false);

  useEffect(() => {
    if (isEntityGalleryShown) {
      setTimeout(() => {
        setIsGallery(true)
      }, 5000);
    }
  }, [isEntityGalleryShown])


  const openModal = useCallback(() => setModal(true), []);
  const closeModal = useCallback(() => setModal(false), []);

  function merge(a, b, prop) {
    var reduced = a?.filter(function (aitem) {
      return !b?.find(function (bitem) {
        return aitem[prop] === bitem[prop];
      });
    });
    return reduced?.concat(b);
  }

  useEffect(() => {
    if (!trailerToShow && trailers && trailers.length) {
      selectTrailer(0);
    }
  }, [trailers]);

  useEffect(() => {
    if (movieDetails?.allStateRatings !== null) {
      const ddd = movieDetails?.allStateRatings;

      if (ddd) {
        const data = JSON.parse(ddd);

        setRatingList(data?.stateFsk);
      }
    }

    setTechnologiesCMSList(
      merge(movieDetails?.availableTechCMS, movieDetails?.availableVersCMS, "id"))



  }, [movieDetails]);

  useEffect(() => {
    if (movieDetails?.gallery && movieDetails?.gallery?.length > 0) {
      setGallery(movieDetails.gallery)
    }
  }, [movieDetails?.gallery])

  const languageContents = useMemo(
    () => ({
      title: i18n.language === 'en' || i18n.language === 'en-US' ? 'TitleEN' : 'title',
    }),
    [i18n.language]
  );

  let CountryCMS = movieDetails.movieCountryCMS?.map((Data) => Data);

  let valueList = '';
  useEffect(() => {
    var id = technologiesContent?.current;
    const idList = document.getElementById("technologies_list");
    valueList = idList?.querySelectorAll("p");
    setTechnologiesContentList([])
    return valueList?.forEach(val => {
      const contenView = val?.textContent;
      const data = technologiesContentList;
      data.push(contenView);
      setTechnologiesContentList(data);
      setTechnologiesContentValue(true);
      val.style.display = 'none';
    })
  }, [technologiesContent?.current])

  useEffect(() => {
    const isMobile = window.innerWidth < 992;
    if (isMobile && isVisible) {
      window.scrollTo(0, 0);
    }
  }, [isVisible])

  return (
    <AsideMovieDetails as="aside" isVisible={isVisible}>
      {trailerToShow !== null ? (
        <Fragment>
          <div className="b-trailer">
            <div className="b-trailer__poster">
              <img
                className="b-trailer__poster-img"
                src={trailers[trailerToShow].keyframeUrl}
                alt=""
              />
              <button type="button" className="b-trailer__btn-play" onClick={openModal}>
                <Svg id="play" />
              </button>
            </div>
          </div>

          {trailers.length > 1 ? (
            <div className="b-trailer__switcher">
              {trailers.map((item, i) => (
                <button
                  key={item.trailerKey}
                  type="button"
                  onClick={() => {
                    selectTrailer(i);
                  }}
                  className={`b-trailer__switcher-btn ${trailerToShow === i ? ' _active' : ''}`}
                />
              ))}
            </div>
          ) : null}
        </Fragment>
      ) : null}

      <div className="s-entity-details__aside-inner">
        {isEntityGalleryShown ? (
          <div className='b-entity-info__carousel'>
            {isGallery ? <EntityGallery gallery={gallery} /> : <Loader />}
          </div>
        ) : null}
        <MovieDescription>
          <Fragment>
            <p
              className={`b-movie-description__text${!isFullDescription && descriptionCalculated ? ' _short' : ''
                }`}
            >
              {descriptionShortCalculated || t('movies.no_description')}
            </p>
            {descriptionCalculated ? (
              <Fragment>
                {isFullDescription ? (
                  <p className="b-movie-description__text">{descriptionCalculated}</p>
                ) : null}
                <Button
                  sm
                  isDefault
                  className="b-movie-description__btn"
                  onClick={() => showMore(!isFullDescription)}
                >
                  {isFullDescription ? t('common.show_less') : t('common.show_more')}
                </Button>
              </Fragment>
            ) : null}
          </Fragment>
        </MovieDescription>

        <EntityInfo>
          {printInfo(titleOriginalCalculated, t('movies.title'))}
          {printInfo(startDate, t('movies.film_start'))}
          {printInfo(toMinutes(runTime), t('movies.runtime'))}

          {country === 'bih' || country === 'bil' ? null : (
            showingOptions.ageratingvisible &&
            (<div className="b-entity-info__row b-entity-info__age">
              <strong className={isClassBlock(rating + t('common.age_rating'))}>
                {t('common.age_rating')}
              </strong>

              {country === 'rou' || !ratingList?.length ? null : (
                <span className="b-entity-info__age-mark">
                  <Svg id="question-mark" />
                </span>
              )}
              {ratingList?.length ?
                <span className="b-entity-info__age-text">
                  {
                    ratingList?.map((item, key) => (
                      <p key={key}>
                        <span className='age_title'>{t(`movie_detail.${item?.stateId}`)} : </span>
                        {item?.fsk?.[languageContents.title]}
                      </p>
                    ))
                  }
                </span>
                : <span className='age_title'>{t(movieDetails?.rating)}</span>}
            </div>
            )
          )}
          {technologiesCMSList?.length > 0
            &&
            <div className='b-entity-info__row' id="technologies_list" ref={technologiesContent}>
              <strong>{t('movies.technologies')}</strong>
              {technologiesCMSList?.map((item, key) => (
                parse(i18n.language === 'en' || i18n.language === 'en-US' ? item?.DescriptionEN : item?.Description)
              ))}
              {technologiesContentValue &&
                <p style={{ fontSize: "14px" }}>
                  {technologiesContentList.join(", ")}
                </p>}
            </div>}
          {CountryCMS && startCMSYear &&
            printInfo(`${CountryCMS?.join("/ ")} ${startCMSYear}`,
              t('movies.country_year'))}
          {i18n?.language === 'en'
            ? printInfo(ratingGetmeshEn, t('movies.ratingGetmesh'))
            : printInfo(ratingGetmesh, t('movies.ratingGetmesh'))}
          {printInfo(actors, t('movies.actors'))}
          {printInfo(directors, t('movies.directors'))}
          {printInfo(distributorName, t('movies.distributor'))}
        </EntityInfo>
      </div>

      <ModalCarousel isOpen={isModal} close={closeModal}>
        <Player
          id={isModal ? trailers[trailerToShow].trailerKey : ''}
          keyFrameUrl={isModal ? trailers[trailerToShow].keyframeUrl : ''}
        />
      </ModalCarousel>
    </AsideMovieDetails>
  );
};

Aside.propTypes = propTypes;
export default Aside;
